import { MakeModel } from 'types/srpFilters';
import { TFunction } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

export function getMakeModelPlaceholder(makeModel: MakeModel, t: TFunction): string {
  if (!makeModel?.make) {
    return t('srp.filters.makeModel');
  }

  if (makeModel.make && !makeModel.model) {
    return makeModel.make;
  }

  return `${makeModel.make} ${makeModel.model}`;
}

export function getTrimPlaceholder(trimsValue: string[], t: TFunction): string {
  if (!trimsValue || trimsValue.length === 0) {
    return t('srp.filters.trim.selectTrim');
  }
  return trimsValue.join(', ');
}

export function getVehicleTitle(makeModel: MakeModel, index: number, t: TFunction): string {
  if (!makeModel?.make) {
    return `${t('srp.filters.vehicle')} ${index + 1}`;
  }

  if (makeModel.make && !makeModel.model) {
    return makeModel.make;
  }

  return `${makeModel.make} ${makeModel.model}`;
}

export function isTrimFilterDisabled(makeModel?: MakeModel): boolean {
  return (
    !makeModel ||
    (!makeModel.model && !makeModel.make) ||
    Boolean(makeModel.make && !makeModel.model)
  );
}

export function checkIfShouldShowTooltip({
  setRenderTooltip,
}: {
  setRenderTooltip: Dispatch<SetStateAction<boolean>>;
}): void {
  const hasViewedMultiMakeModel = localStorage.getItem('hasViewedMultiMakeModel');
  console.log('hasViewedMultiMakeModel', hasViewedMultiMakeModel);
  if (!hasViewedMultiMakeModel) {
    setRenderTooltip(true);

    localStorage.setItem('hasViewedMultiMakeModel', 'true');
  }
}
